module.exports = __webpack_public_path__ + "img/JET_0049@2x.efcfadbc.png";